import "./App.css";

const sections = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "resources", label: "Resources" },
  { id: "contact", label: "Contact" },
  { id: "policy", label: "Policies" },
];

function App() {
  return (
    <div className="app-shell">
      <nav className="primary-nav">
        <span className="logo">Kate Haverty</span>
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`}>{section.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <header className="hero" id="about" style={{ backgroundImage: 'url("/images/hero-bg.jpg")' }}>
        <img 
          src="/uploads/hero.jpg" 
          alt="Professional portfolio of Kate Haverty showcasing her skills and experiences in management." 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Kate Haverty · Empowering Your Journey</p>
        <h1>Welcome to Kate Haverty</h1>
        <p className="lede">
          At Kate Haverty, we believe in the power of transformation. Our mission is to empower individuals and businesses to reach their full potential through innovative solutions and personalized support. With a focus on quality and integrity, we strive to create lasting relationships with our clients.
        </p>
        <div className="cta-row">
          <a href="/services" className="primary-cta">Explore Our Services</a>
          <a href="/blog" className="secondary">Visit Our Blog</a>
        </div>
      </header>

      <section className="narrative">
        <h2>Your Partner in Growth</h2>
        <p>
          In today's fast-paced world, having a reliable partner can make all the difference. At Kate Haverty, we offer a range of services designed to help you navigate challenges and seize opportunities. Our team of experts is dedicated to providing tailored solutions that meet your unique needs. Whether you're looking to enhance your online presence, streamline operations, or develop new strategies, we are here to support you every step of the way.
        </p>
        <p>
          Our approach is centered around understanding your goals and crafting strategies that align with your vision. We take the time to listen and collaborate, ensuring that our solutions are not only effective but also sustainable. With our extensive experience across various industries, we bring a wealth of knowledge and insights to the table, empowering you to make informed decisions.
        </p>
        <p>
          We are proud to share success stories from our clients who have transformed their businesses with our help. From startups to established enterprises, our clients have experienced significant growth and improved performance. Join us on this journey and discover how we can help you achieve your aspirations.
        </p>
        <p>
          Explore our blog for the latest insights and trends in the industry. Here are a few articles you might find interesting:
        </p>
        <ul>
          <li><a href="/blog/5-tips-for-success">5 Tips for Success in Your Business</a></li>
          <li><a href="/blog/the-importance-of-branding">The Importance of Branding in Today's Market</a></li>
          <li><a href="/blog/how-to-navigate-change">How to Navigate Change Effectively</a></li>
        </ul>
        <p>
          Our commitment to your success goes beyond just providing services. We believe in building a community where knowledge is shared, and growth is fostered. Join our newsletter to stay updated on the latest trends and insights that can help you thrive in your industry.
        </p>
        <p>
          We also invite you to connect with us on social media. Follow us on Instagram, Facebook, and LinkedIn to see how we are making an impact and to engage with our community.
        </p>
      </section>

      <section className="cards" id="services">
        <article>
          <h2>Deploy quickly</h2>
          <p>
            Push to GitHub and Amplify Web Compute will build, deploy, and host the optimized assets
            automatically with every commit.
          </p>
        </article>
        <article>
          <h2>Customize freely</h2>
          <p>
            Tailor the layout, connect APIs, or drop in generated content. This starter keeps things
            lightweight so you can iterate rapidly.
          </p>
        </article>
        <article>
          <h2>Automate updates</h2>
          <p>
            Pair this repo with Skighnet automations to regenerate pages, thumbnails, and analytics on
            a schedule.
          </p>
        </article>
        <article>
          <h2>Monetize responsibly</h2>
          <p>
            Every template includes AdSense-ready zones, policy pages, and clear navigation so you can
            activate monetization without extra setup.
          </p>
        </article>
      </section>

      <section className="resources" id="resources">
        <div className="resource-card">
          <h3>Documentation</h3>
          <p>Review the README to understand deployment, configuration, and automation.</p>
        </div>
        <div className="resource-card">
          <h3>Placeholder Articles</h3>
          <p>Swap these stubs with real stories or announcements. Ensure no page ships empty.</p>
        </div>
        <div className="resource-card">
          <h3>Contact & Legal</h3>
          <p>Dedicated About, Contact, Terms, and Privacy pages are provided under /about etc.</p>
        </div>
      </section>

      <section className="contact" id="contact">
        <div>
          <h2>Contact</h2>
          <p>Have questions about our services? Reach out to us!</p>
          <ul>
            <li>Email: hello@katehaverty.com</li>
            <li>Phone: (123) 456-7890</li>
            <li>Location: Your City, USA</li>
          </ul>
        </div>
        <form>
          <label>
            Name
            <input type="text" placeholder="Jane Doe" required />
          </label>
          <label>
            Email
            <input type="email" placeholder="you@example.com" required />
          </label>
          <label>
            Message
            <textarea rows={4} placeholder="How can we help?" required />
          </label>
          <button type="submit">Send Message</button>
        </form>
      </section>

      <section className="policies" id="policy">
        <h2>Policies & Compliance</h2>
        <p>
          This starter bundles essential compliance resources. Customize the linked pages in{" "}
          <code>public/</code> to match your organization.
        </p>
        <ul className="policy-links">
          <li><a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a></li>
          <li><a href="/terms" target="_blank" rel="noreferrer">Terms of Service</a></li>
          <li><a href="/contact" target="_blank" rel="noreferrer">Contact</a></li>
          <li><a href="/about" target="_blank" rel="noreferrer">About</a></li>
        </ul>
      </section>

      <div id="adsense" className="adsense-slot">
        <p>AdSense placeholder — replace with your ad code.</p>
      </div>

      <footer className="footer">
        <p>This site is for informational purposes only. Please consult a professional for specific advice.</p>
      </footer>
    </div>
  );
}

export default App;